export default {"src":"/_next/static/media/ipo-logo.4fdd4895.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};